// UploadFastaService.ts

import type { IFastaRepository } from "@domain/repositories";
import { FastaFile } from "@domain/schemas/BI";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";

@injectable()
class UploadFastaService {
  @inject(TYPES.IFastaRepository)
  private _fastaRepository!: IFastaRepository;

  async uploadFastaAsync(file: File, onProgress: (progress: number) => void): Promise<FastaFile> {
    return this._fastaRepository.uploadFileAsync(file, onProgress);
  }
}

export { UploadFastaService };
